import React, { useEffect, useState } from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import { s3FileManagerServices } from "../../../APIServices/SitePilotManagement/s3FileManagerServices";

const AddNewFolder = ({ Show, Hide, Title, folderData, getTotalS3Folders }) => {
  const [buttonLoader, setButtonLoader] = useState(false);
  const [name, setName] = useState("");

  const createS3Folder = async () => {
    setButtonLoader(true)
    let userData = {  };
    userData.folder = `${folderData?.fullPath || ""}${name}`
    let data = await s3FileManagerServices.createS3Folder(
      userData
    );
    setButtonLoader(false)
    if (data?.statusCode === 200) {
      setName("")
      getTotalS3Folders()
      Hide()
    }
  };

  return (
    <>
      <Modal show={Show} onHide={Hide} placement="end">
        <Modal.Header closeButton>
          <Modal.Title style={{fontSize: 15}}>{Title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              Folder Name{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              type="text"
              rows={3}
              onChange={(e) => setName(e.target.value)}
              value={name}
              className={`fontSize12 ${name === "Uncategories" ? "border-danger" : ""}`}
              placeholder="Enter Folder Name"
            />
          </Form.Group>
          {name === "Uncategories" && (
            <span style={{ fontSize: 10, color: "red", fontWeight: 600 }}>
              Uncategories name is Default Folder Name, Please Change Name
            </span>
          )}
        </Modal.Body>
        <div className="text-end p-2 border-top">
          <Button
            size="sm"
            variant="outline-primary"
            onClick={createS3Folder}
            // disabled={buttonLoader || !name || name === "Uncategories"}
            title={Title}
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Adding...
              </div>
            ) : (
              "Add Now"
            )}
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default AddNewFolder;
